<template>
<div class="chapter">
<div class="inner_page">
<p class="image"><img alt="images" src="images/f020-01.jpg" width="80%"/></p>
<p class="caption"><em class="italic">Australian troops in 1916 at the Bridoux Road Salient, Bois-Grenier. The low water table in this sector of the Western Front required the construction of breastworks above ground level</em>.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// 30_fm0313.vue?ae81967c